import { PathOptions } from "leaflet";

export const corpos_dagua = (feature: any): PathOptions => {
  return {
    color: "#1E90FF",
    weight: 1,
    opacity: 0.8,
    fillColor: "#4169E1",
    fillOpacity: 0.4,
  };
};
